module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"coupons":{"sub_title":"사용 가능한 쿠폰 목록","expires_at":"사용 기한: {0} 까지","unlimited":"사용 기한: 무기한"},"button":"내 쿠폰 보러가기","hint":"*쿠폰 만료 시간에 따라 이미 만료된 쿠폰이 표시될 수 있습니다.\\n내 쿠폰 보러가기 버튼을 클릭하여 더 정확한 확인이 가능합니다."}}')
  delete Component.options._Ctor
}
